<div class="grid w-full grid-cols-2 md:grid-cols-6 gap-4">
	<slot />
</div>